import styled, { css } from 'styled-components'
import { pageCenter } from 'styles/page-center.styles'

const TABLE_HEIGHT = '500px'

export const TableWrapper = styled.div`
  height: ${TABLE_HEIGHT};
  overflow: auto;
  border: 1px solid ${({ theme }) => theme.palette.border.light};
`

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;

  thead tr:nth-child(1) th {
    background: ${({ theme }) => theme.palette.background.paper};
    position: sticky;
    top: -1px;
    z-index: 10;
  }

  & thead {
    position: sticky;
  }

  & tr {
    border: 1px solid ${({ theme }) => theme.palette.border.light};
  }

  & td,
  & th {
    border: 1px solid ${({ theme }) => theme.palette.border.light};
    padding: 0.5rem;
  }
`

export const StatCards = styled.div`
  padding-top: ${({ theme }) => theme.spacing(4)};
  padding-bottom: ${({ theme }) => theme.spacing(2)};
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > div {
    margin: 0;
    @media (max-width: 43.75rem) {
      width: 100%;
    }
  }

  && > * + * {
    margin-left: 1rem;
  }

  @media (max-width: 43.75rem) {
    flex-wrap: wrap;

    && > * + * {
      margin-left: 0;
      margin-top: 2rem;
    }
  }
`

export const Container = styled.div`
  ${pageCenter};
`

export const LoaderCellWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const NoHistoryFound = styled.div`
  ${({ theme }) => theme.typography.heading2};
  position: relative;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    font-weight: bold;
    text-decoration: underline;
  }
`
export const CharacterBasedFilterContainer = styled.div`
  max-width: 100%;
  background-color: #fff;
  box-shadow: 0 0 0 1px #ddd;
  border-radius: 3px;
  padding: 1px;
  margin: 0 auto;
  user-select: none;
  display: flex;
  width: 482px;
  margin: 0 auto;
`
export const CharacterBasedCheckboxes = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 1px;

  ${({ theme }) => css`
    ${theme.breakpoints.down.md} {
      flex-wrap: wrap;
    }
  `}
`

export const CheckboxWrapper = styled.div<{ selected: boolean; color: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  flex-grow: 1;
  padding: 0 1rem;
  font-size: 14px;
  cursor: pointer;
  text-transform: capitalize;

  .character-based-category-checkbox {
    color: ${({ color }) => color};
    background-color: white;
    padding-bottom: 1px;
  }

  ${({ selected, color }) =>
    selected &&
    css`
      background-color: ${color};
      box-shadow: none;
      color: #fff;
    `};
`
